window.addEventListener('load', event => {
    let animateTextTargets = document.querySelectorAll('.animate-text-colour');
    let scrolledY = window.scrollY;

    for (let animateTextTarget of animateTextTargets) {

        const intersectionChanged = function (entry) {
            if (entry.isIntersecting) {
                document.addEventListener('scroll', throttleScroll, {passive: true})
            } else {
                document.removeEventListener('scroll', throttleScroll);
            }
        };

        const callback = (entries, observer) => {
            entries.forEach(intersectionChanged);
        };

        const options = {
            threshold: 0.1
        };

        const observer = new IntersectionObserver(callback, options);
        observer.observe(animateTextTarget);

        let throttleScroll =  _throttle(highlightText, 32, {leading: true, trailing: true});

        highlightText(true);

        const setOnLoad = setTimeout(throttleScroll, 50);

        function highlightText(onLoad) {
            let scrollTop = window.scrollY;
            if ((scrollTop !== scrolledY) || (onLoad === true)) {
                scrolledY = window.scrollY;

                let topOfTarget = animateTextTarget.getBoundingClientRect().top;
                let centerOfTarget = topOfTarget + (animateTextTarget.offsetHeight * .5);
                let windowHeight = window.innerHeight;

                // start = percentage from bottom of screen to start animating
                let start = 20;
                if (animateTextTarget.dataset.start) {
                    start = animateTextTarget.dataset.start;
                }

                // finish = percentage from bottom of screen to finish animating
                let finish = 50;
                if (animateTextTarget.dataset.finish) {
                    finish = animateTextTarget.dataset.finish;
                }

                let yPositionPercent = 100 - Math.round(centerOfTarget / windowHeight * 100) - start;

                let highlightText = animateTextTarget.querySelectorAll('span');
                let index = 0;

                for(let character of highlightText) {
                    index = index + ((finish - start) / highlightText.length);
                    const defaultColour = character.dataset.defaultColour;

                    if (index > yPositionPercent) {
                        character.classList.add(defaultColour);
                    } else {
                        character.classList.remove(defaultColour);
                    }
                }
            }
        }
    }
});